import React from 'react';
import Slider from 'react-slick';

import Config from '@app/dev/config/main';

import { BannerItemRemote } from './banner-item-remote';
import { BannerItem } from './banner-item';

import './style.scss';
import { ascSort } from '@common/helpers/declarative/sortings';

const Banner = ({ slides }) => {
  if (!slides?.length) return null;

  if (slides.length === 1) return Config.home.enableRemoteBanners ? <BannerItemRemote {...slides[0]} /> : <BannerItem {...slides[0]} />;

  const sliderContent = slides.sort(ascSort('index')).map((slide, index) => (
    Config.home.enableRemoteBanners
      ? <BannerItemRemote {...slide} key={index} />
      : <BannerItem {...slide} key={index} index={index + 1} />
  ));

  return (
    <div className="home-banner-slides">
      <Slider
        dots={false}
        accessibility={false}
        arrows={false}
        autoplay
        infinite={sliderContent.length > 1}
        draggable={slides.length > 1}
        autoplaySpeed={5000}
        dragging={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {sliderContent}
      </Slider>
    </div>
  );
};

export default Banner;
